import { createIntlCache, createIntl } from '@formatjs/intl';
import { useState, useEffect, useMemo, useCallback } from 'react';
import '../contexts/MenuContext/index.mjs';
import { DEFAULT_LANGUAGE } from '../contexts/MenuContext/mapping.mjs';
import { Language } from '../types/constants.mjs';
import { useMenu } from '../contexts/MenuContext/context.mjs';
"use strict";
const REMAPPED_LANGUAGES = {
  [Language.Pt]: Language.PtBr,
  [Language.Es]: Language.EsEs
};
const getResolvedLanguage = lang => {
  return REMAPPED_LANGUAGES[lang] ?? lang ?? "en";
};
const isIncludedLanguage = currentLanguage => currentLanguage !== DEFAULT_LANGUAGE && currentLanguage !== Language.Es && currentLanguage !== Language.Pt;
const useTranslationRaw = ({
  language,
  defaultTranslation,
  additionalTranslations
}) => {
  const [activeTranslation, setActiveTranslation] = useState(defaultTranslation);
  useEffect(() => {
    const loadTranslations = async () => {
      try {
        const resolvedLanguage = getResolvedLanguage(language);
        if (resolvedLanguage === DEFAULT_LANGUAGE) {
          setActiveTranslation(defaultTranslation);
          return;
        }
        if (isIncludedLanguage(resolvedLanguage)) {
          const includedLang = resolvedLanguage;
          const translationsToLoad = additionalTranslations[includedLang];
          if (!translationsToLoad) {
            console.warn(`No translation found for language: ${language}`);
            return;
          }
          const loadedTranslations = await translationsToLoad();
          setActiveTranslation(loadedTranslations);
          return;
        }
        console.warn(`Language ${language} is excluded from loading`);
      } catch {
        console.error(`Failed to load translation ${language}`);
      }
    };
    loadTranslations().catch(() => {
      console.error(`Failed to load translation ${language}`);
    });
  }, [language, additionalTranslations, defaultTranslation]);
  const intl = useMemo(() => {
    const cache = createIntlCache();
    return createIntl({
      locale: language,
      messages: activeTranslation
    }, cache);
  }, [language, activeTranslation]);
  const formatMessage = useCallback((id, values) => intl.formatMessage({
    id,
    defaultMessage: defaultTranslation[id]
  }, values), [intl, defaultTranslation]);
  return {
    intl,
    formatMessage
  };
};
const useTranslation = options => {
  const {
    language
  } = useMenu();
  const optionsExtended = useMemo(() => ({
    ...options,
    language
  }), [options, language]);
  return useTranslationRaw(optionsExtended);
};
export { getResolvedLanguage, useTranslation, useTranslationRaw };
//# sourceMappingURL=useTranslation.mjs.map
